// @see https://support.connectif.ai/hc/es/articles/360014712720-Notificar-evento-de-producto-visitado#h_01J28ZJCVEC1Q4RWGM8KQM0012

declare global {
  interface Window {
    fbq: any // Reemplaza 'any' con el tipo correcto si lo conoces
  }
}

export default function useMeta() {
  const config = useRuntimeConfig()
  const { onLoaded, proxy } = useScriptMetaPixel({
    id: `${config.public.META_PIXEL_ID}`,
  })

  const sendProductVisit = (data: any) => {
    onLoaded(() => {
      proxy.fbq('track', 'ViewContent', data)
    })
  }

  const sendCart = (cartData: any, currency: any) => {
    const total = cartData.totals.find(
      (total: any) => total.type === 'total'
    ).value
    onLoaded(() => {
      proxy.fbq('track', 'AddToCart', {
        content_ids: cartData.items.map((item: any) => `${item.product_id}`),
        content_type: 'product',
        contents: cartData.items.map((item: any) => ({
          id: `${item.product_id}`,
          quantity: item.qty,
        })),
        currency: currency.code,
        value: total,
      })
    })
  }

  const sendPurchase = (purchaseData: any) => {
    const shipment = purchaseData.shipments.length
      ? purchaseData.shipments[0]
      : []
    const items = shipment?.items.length ? shipment.items : []
    onLoaded(() => {
      proxy.fbq('track', 'Purchase', {
        content_ids: items?.map((item: any) => `${item.product_id}`),
        content_type: 'product',
        contents: items?.map((item: any) => ({
          id: `${item.product_id}`,
          quantity: item.qty,
        })),
        num_items: items?.reduce((acc: number, item: any) => acc + item.qty, 0),
        currency: purchaseData.currency.code,
        value: purchaseData.total,
      })
    })
  }

  return {
    sendProductVisit,
    sendCart,
    sendPurchase,
  }
}
